import * as React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { __ } from '../../helpers/TranslationService';
import classnames from 'classnames';
import { MarketContext } from '../../context/markets';
import { config } from '../../config';

interface IProps {
    children: any;
    backgroundImage: string;
    headline: string;
    subHeadline: string;
    learnMoreHandler?: () => void;
}
export const SearchSection = ({
    children,
    backgroundImage,
    headline,
    subHeadline,
    learnMoreHandler,
}: IProps) => {
    const { deviceType: stateDeviceType } = useSelector((state: RootStateOrAny) => state.pageData);
    const { markets } = React.useContext(MarketContext);
    const { isCruise1st } = markets;
    const isDesktop = stateDeviceType === 'desktop';
    const isDefaultBackground = backgroundImage === null;
    const defaultImage = '/common/header-ships-general-2022.jpg';
    const newBackgroundImage = isDefaultBackground
        ? `url("${config.images}${defaultImage}")`
        : `url("${backgroundImage}")`;

    const classes = classnames('searchSection', {
        'searchSection-indigo': isCruise1st,
    });

    return (
        <div
            className={classes}
            style={{ backgroundImage: isDesktop ? newBackgroundImage : 'none' }}
        >
            <div className="searchSectionLayer"></div>
            <div className="searchSectionContainer">
                <div className="searchFilter">{children}</div>
                <div className="searchSectionDesc onlyDesktop">
                    <span className="headline">{headline}</span>
                    <div
                        className="subheadline"
                        dangerouslySetInnerHTML={{ __html: subHeadline }}
                    />
                    {learnMoreHandler && (
                        <span className="searchSectionDesc-link" onClick={learnMoreHandler}>
                            {__('learnMore', 'dreamlines')}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};
